import React, {Component} from 'react';
import 'normalize.css/normalize.css'
import './App.css';
import IndecisionApp from "./Playground/IndecisionApp/IndecisionApp";

class App extends Component {

    render() {
        return (
            <IndecisionApp/>
        );
    }
}

export default App;
